module.exports = "<svg viewBox=\"0 0 11 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.132 6.066a.844.844 0 0 1-1.188.006L1.252 2.446a.844.844 0 1 1 1.183-1.204L5.542 4.28 8.56 1.248A.844.844 0 1 1 9.752 2.44l-3.62 3.626z\" stroke-width=\"2\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader!./src/images/svg/down-caret.svg
// module id = a5ts
// module chunks = 89